<!--  -->
<template>
  <div class="workorer-container">
    <div id="workorerStaticsChart" style="height: 100%; width: 100%"></div>
  </div>
</template>

<script>
import echarts from "echarts";
import API from "../api/index.js";
export default {
  data() {
    return {
      workorerStaticsChart: null,
      workorerStaticsChartOption: {},
      optionData: {
        alarmWorkOrderPendingCount: 0,
        alarmWorkOrderPendCount: 0,
        alarmWorkOrderCount: 0,
      },
    };
  },

  components: {},

  // computed() {},

  mounted() {
    var self = this;

    self.workorerStaticsChart = echarts.init(
      document.getElementById("workorerStaticsChart")
    );
    self.queryDataNew().then((res) => {
      self.initTypeChartOption(res);
    });
  },

  methods: {
    // queryData() {
    //   return new Promise((reolve, reject) => {
    //     this.$fetch(API.security.statAlarmTotal, { processType: "2" }).then(
    //       (res) => {
    //         if (res.success) {
    //           this.optionData.alarmWorkOrderPendingCount =
    //             res.returnObj.alarmWorkOrderPendingCount;
    //           this.optionData.alarmWorkOrderPendCount =
    //             res.returnObj.alarmWorkOrderPendCount;
    //           this.optionData.alarmWorkOrderCount =
    //             res.returnObj.alarmWorkOrderCount;
    //           console.log(this.optionData, ">>>>this.optionData");
    //           reolve(this.optionData);
    //         }
    //       }
    //     );
    //   });
    // },
    queryDataNew() {
      return new Promise((reolve, reject) => {
        this.$fetch(API.security.statisticsAlarmTotal, {
          "alarmTypeList": ["50111"],
          "subSystemList": [5, 9, 10, 11, 17]
        }).then(
          (res) => {
            if (res.success) {
              this.optionData.alarmWorkOrderPendingCount = res.returnObj.alarmWorkOrderPendingCount;
              this.optionData.alarmWorkOrderPendCount = res.returnObj.alarmWorkOrderPendCount;
              this.optionData.alarmWorkOrderCount = res.returnObj.alarmWorkOrderCount;
              reolve(this.optionData);
            }
          }
        );
      });
    },
    initTypeChartOption(chartData) {
      this.workorerStaticsChart = echarts.init(
        document.getElementById("workorerStaticsChart")
      );

      let data = [
        {
          value: chartData.alarmWorkOrderPendCount,
          name: "今日已处理",
          label: {
            normal: { show: true, position: "inner", formatter: "{d}%" },
          },
        },
        {
          name: "今日未处理",
          value: chartData.alarmWorkOrderPendingCount,
          label: {
            normal: { show: true, position: "inner", formatter: "{d}%" },
          },
        },
      ];
      this.workorerStaticsChartOption = {
        // title: {
        //   text: "告警类型",
        //   top: "35%",
        //   left: "48%",
        //   textAlign: "center",
        //   textStyle: {
        //     color: "#fff",
        //     fontSize: "12px",
        //   },
        // },
        graphic: [
          {
            //环形图中间添加文字
            type: "text", //通过不同top值可以设置上下显示
            left: "center", //
            top: "35%",
            style: {
              text: this.optionData.alarmWorkOrderCount,
              textAlign: "center",
              fill: "#fff", //文字的颜色
              fontSize: 28,
              lineHeight: 16,
            },
          },
          {
            //环形图中间添加文字
            type: "text", //通过不同top值可以设置上下显示
            left: "center", //
            top: "47%",
            style: {
              text: "工单总数",
              textAlign: "center",
              fill: "#fff", //文字的颜色
              fontSize: 16,
              fontWeight: 400,
              lineHeight: 16,
            },
          },
        ],

        tooltip: {
          // trigger: 'item',
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        legend: {
          //   orient: "vertical",
          //   top: "70%",
          bottom: 0,
          textStyle: {
            color: "#fff",
            fontSize: 12,
          },
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 112,
          // selectedMode: false,
        },
        color: ["#47A6FF", "#FF6188", "#58A55C", "rgba(243,114,44,1)"],
        series: [
          {
            name: "工单处理",
            type: "pie",
            radius: ["40%", "67%"],
            center: ["50%", "40%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            itemStyle: {
              borderRadius: 10,
              borderColor: "rgba(100,103,120,.4)",
              // borderColor: "transparent",

              borderWidth: 10,
            },
            emphasis: {
              label: {
                show: false,
                fontSize: "20",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: data,
            roundCap: 2, //可选项为1和2，不填则采用原有拼接方式
          },
        ],
      };

      this.workorerStaticsChart.setOption(this.workorerStaticsChartOption);
    },
  },
};
</script>
<style lang='scss' scoped>
.workorer-container {
  height: 100%;
}
</style>